export enum AVSResultType {
  Matched = 'Matched',
  PartialMatch = 'Partial Match',
  NotChecked = 'Not Checked',
  NotSet = 'Not Set',
  NotMatched = 'Not Matched'
}
